import React, {useEffect, useState} from 'react'
import {Tab, Tabs} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {useLocation, useNavigate} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {CreateData, UpdateData} from './OptoutSlice/OptoutListSlice'
import './OptOut.scss'
import {openPopup} from '../../../Components/PopupSlice/popupSlice'

const OptOutPopup = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const param: any = useLocation()
  const [outoutdata, setOptoutData] = useState({
    name: '',
    description: "We're sorry to see you go! Are you still interested in any of these contents?",
  })
  const [error, setError] = useState<any>()
  const [formValues, setFormValues] = useState([{option: 'Not interested'}, {option: ''}])

  const handleChange = (i: any, e: any) => {
    let newFormValues: any = [...formValues]
    newFormValues[i][e.target.name] = e.target.value
    setFormValues(newFormValues)
  }

  const addFormFields = () => {
    if (formValues.length < 4) {
      setFormValues([...formValues, {option: ''}])
    }
  }

  const removeFormFields = (i: any) => {
    if (formValues.length > 2) {
      let newFormValues = [...formValues]
      newFormValues.splice(i, 1)
      setFormValues(newFormValues)
    } else {
      dispatch(openPopup('Atleast two option are required'))
      // alert('Atleast two option are required')
    }
  }

  useEffect(() => {
    if (param.state) {
      let data = param?.state?.data?.options?.map((key: any, index: any) => {
        let keyLabel = `option${index + 1}`
        return {option: key?.[keyLabel]}
      })

      setFormValues(data)
      setOptoutData({
        ...outoutdata,
        name: param?.state?.data?.title,
        description: param?.state?.data?.description,
      })
    }
  }, [param])

  const handleSave = () => {
    if (Object.keys(validation(outoutdata)).length == 0) {
      if (param?.state) {
        dispatch(
          UpdateData({
            data: {
              title: outoutdata.name,
              options: formValues.map((key: any, index: number) => {
                let keyLabel = `option${index + 1}`
                return {[`${keyLabel}`]: key.option}
              }),
              description: outoutdata.description,
            },
            id: param?.state?.data?._id,
          })
        )
        navigate('/opt-out-list')
      } else {
        dispatch(
          CreateData({
            title: outoutdata.name,
            options: formValues.map((key: any, index: number) => {
              let keyLabel = `option${index + 1}`
              return {[`${keyLabel}`]: key.option}
            }),
            description: outoutdata.description,
          })
        )
        navigate('/opt-out-list')
      }
    }
  }

  const validation = (data: any) => {
    const errors: any = {}

    if (!data.name?.trim()) {
      errors.name = 'Please enter Name'
    }
    if (!data.description?.trim()) {
      errors.description = 'Please enter description'
    }

    formValues.forEach((item: any, i: any) => {
      const optionKey = `option${i}`
      if (!item.option?.trim()) {
        errors[optionKey] = 'Please enter value'
      }
    })
    setError(errors)
    return errors
  }

  return (
    <>
      <div className='card p-5'>
        <div className='card-header border-0 pt-8 px-9'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-2 mb-1'>Create your custom opt-out page</span>
            <span className='text-muted mt-1 fw-bold fs-7'>
              If you still need more info, visit our{' '}
              <a onClick={() => dispatch(openPopup('Dummy text'))}>Help page</a>
            </span>
          </h3>
        </div>
        <div className='row p-10'>
          <div className='col-lg-12 col-xl-8 col-md-12 col-12'>
            <div className='mt-5 opt-out-form mw-500px'>
              <label className='mb-2'>Template Name</label>
              <input
                value={outoutdata.name}
                onChange={(e: any) => setOptoutData({...outoutdata, name: e.target.value})}
                className='form-control form-control-lg form-control-solid mb-7'
                placeholder='Cool template'
                data-testid='inputTemplateName'
              />
              <span className='text-danger'>{error?.name}</span>

              <label className='mb-2'>Description</label>
              <textarea
                value={outoutdata.description}
                onChange={(e: any) => setOptoutData({...outoutdata, description: e.target.value})}
                className='form-control form-control-lg form-control-solid mb-5'
              />
              <span className='text-danger'>{error?.description}</span>

              <label className='fw-bolder'>Customize fields</label>
              <span className='mb-5 d-block' style={{color: '#838492'}}>
                Choose which options your customer will have
              </span>

              {formValues?.map((key: any, index: any) => (
                <div key={index} className='col-md-6 mb-4 col-lg-11 input-delete'>
                  <input
                    value={key.option}
                    type='text'
                    placeholder={`Option ${index + 1}`}
                    onChange={(e: any) => handleChange(index, e)}
                    name={'option'}
                    className='form-control form-control-solid'
                  />
                  <i onClick={() => removeFormFields(index)} className='bi bi-x'></i>
                  <span className='text-danger'>{error?.[`option${index}`]}</span>
                </div>
              ))}

              {/* <div className="col-md-6 mb-3 col-lg-10">
        <input type="text" className="form-control form-control-solid" id="validationCustom01"/><i className='bi bi-x'></i>
      </div> */}
              <div className='col-md-6 mb-15 col-lg-11'>
                <button
                  className='btn gray_bg_purple w-100'
                  disabled={formValues?.length == 4}
                  onClick={addFormFields}
                >
                  <i className='bi bi-plus'></i> Add new option
                </button>
              </div>
            </div>

            <div className='mb-10'>
              <div className='d-flex flex-start'>
                <button
                  disabled={formValues.filter((key: any) => key.option == '')?.length > 1}
                  className='btn btn-md btn-light btn-primary me-2 w-100px p-3 fw-500 me-2'
                  type='button'
                  data-kt-element='send'
                  onClick={handleSave}
                >
                  Save
                </button>
                {/* <button
                  className='btn btn-sm btn-light fw-500 text-primary text-hover-white bg-white btn-active-primary w-100px p-3 border border-primary'
                  type='button'
                  data-kt-element='send'
                >
                  Cancel
                </button> */}
              </div>
            </div>
          </div>

          <div className='d-flex flex-start col-xl-4 col-sm-12 step2-main '>
            <div
              className='mobile-bg-wrapper grey-bg'
              style={{
                backgroundImage: `url(${toAbsoluteUrl('/media/mobile/newiphone.png')})`,
              }}
            >
              <div style={{backgroundColor: '#f7f8fa'}} className='inner-content-main'>
                <h4>Opt-Out Survey</h4>
                <span>{outoutdata.description}</span>

                {formValues?.filter((key: any) => key?.option !== '')?.length > 0 && (
                  <div className='d-flex flex-column w-70 mb-3'>
                    {formValues?.map((key: any, i: number) => (
                      <div className='landingpage_inside_label' key={i}>
                        <label className='form-check form-check-sm form-check-custom form-check-solid mw-100 mt-5'>
                          <input type='radio' className='form-check-input me-4' name='option' />
                          {key.option}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
                {/* {formValues?.map((val: any) => (
                  <h6>{val.option}</h6>
                ))} */}
              </div>
              {/* <div className='wrapper-tabs'>
                <Tabs
                  defaultActiveKey='notification'
                  className='nav nav-tabs nav-pills border rounded p-2 fs-6 text-dark d-flex justify-content-between'
                >
                  <Tab eventKey='notification' title='Notification' />
                  <Tab eventKey='message' title='Message' />
                </Tabs>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OptOutPopup
